import { render, staticRenderFns } from "./GamesCompare.vue?vue&type=template&id=249c1379"
import script from "./GamesCompare.vue?vue&type=script&lang=js"
export * from "./GamesCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports